import Header from 'pages/charterQuote/components/contents/Header';
import { vw } from 'components/common/Common';
import styled from 'styled-components';
import React from 'react';

const Container = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${vw(60)};
  article {
    width: 100%;
    text-align: left;
    padding: ${vw(100)};
  }
`;

const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${vw(16)};
  padding: 0 0 ${vw(20)} 0;
  min-height: 600px;
`;

const Tabs = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${vw(12)};
`;

const TabButton = styled.button`
  width: 100%;
  text-align: left;
  padding: ${vw(16)};
  background: ${(props) => (props.$active ? '#1f68db' : '#F4F6FC')};
  color: ${(props) => (props.$active ? '#ffffff' : '#050A30')};
  border-radius: ${vw(4)};
  font-weight: 600;
  cursor: pointer;
  font-size: 20px;
`;

const Panel = styled.div`
  background: #1f68db;
  color: #ffffff;
  border-radius: ${vw(2)};
  padding: ${vw(16)};
  display: flex;
  flex-direction: column;
  gap: ${vw(32)};
`;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
`;

const PanelTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
`;

const PanelDesc = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 1.3;
  color: #fdfeff;
`;

const PanelRate = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: 20px;
  line-height: normal;
  color: #fdfeff;
`;

const BookBtn = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${vw(180)};
  height: ${vw(40)};
  background: #b7e1ff;
  color: #050a30;
  border-radius: ${vw(4)};
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
`;

const RightPanel = styled.div`
  width: 100%;
  background: #f4f6fc;
  border-radius: ${vw(2)};
  padding: ${vw(24)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${vw(24)};
`;

const Plane = styled.img`
  width: 80%;
  height: 392px;
  object-fit: contain;
`;

const ModelsTitle = styled.div`
  font-weight: 600;
  color: #050a30;
  font-size: 20px;
`;

const Models = styled.div`
  width: fit-content;
  text-align: center;
  font-size: 16px;
  color: #050a30;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 16px;
`;

const tabs = [
  {
    key: 'light',
    title: 'Light Fleet',
    capacity: 'Fits a group of up to 6–8 passengers.',
    desc: 'Catching a flight upstate? Looking for a more accessible and seamless travel experience than first class? Light jets in our network offer a comfortable, luxurious way to travel that’s quick and cost‑effective.',
    rate: 'Rates range from $7,905 to $8,255 per hour.',
  },
  {
    key: 'midsize',
    title: 'Midsize Fleet',
    capacity: 'Fits a group of up to 8–10 passengers.',
    desc: 'Small to medium‑sized groups can enjoy the flexibility to fly anywhere with access to midsize jets. These aircraft provide additional space, premium amenities, and extended range, making them ideal for business or leisure travel.',
    rate: 'Rates range from $9,150 to $9,500 per hour.',
  },
  {
    key: 'large',
    title: 'Super-Midsize Fleet',
    capacity: 'Fits a group of up to 12 passengers.',
    desc: 'Experience top‑class luxury, specialized service, and high‑speed comfort with access to super‑midsize jets. Perfect for long‑range trips with spacious cabins, advanced entertainment, and high‑end onboard amenities.',
    rate: 'Rates range from $10,050 to $10,600 per hour.',
  },
  {
    key: 'heavy',
    title: 'Heavy Fleet',
    capacity: 'Fits a group of up to 14 passengers.',
    desc: 'Larger groups can relax in the comfortable and easily accessible cabins of heavy jets, available through our network. These aircraft offer premium luxury and extended range, making them perfect for long‑haul journeys.',
    rate: 'Rates range from $14,250 to $14,600 per hour.',
  },
  {
    key: 'ultra',
    title: 'Ultra Long Range Fleet',
    capacity: 'Fits a group of up to 13–16 people.',
    desc: 'For those requiring more space, greater capacity, or enhanced luxury, ultra-long-range jets set the standard in private aviation. Your private jet card provides access to aircraft with the most cabin space, top-tier amenities, and maximum comfort for extended flights.',
    rate: 'Rates range from $17,250 to $17,600 per hour.',
  },
];

const cardByKey = {
  light: {
    src: '/imgs/svg/jet/Jet-4.svg',
    models: ['Phenom 300', 'Citation CJ3', 'Hawker 400XP', 'Nextant 400XTi'],
    alt: 'Light jet or short journeys and small groups',
  },
  midsize: {
    src: '/imgs/svg/jet/Jet-3.svg',
    models: ['Hawker 800XP', 'Citation XLS+', 'Learjet 60', 'Citation Excel'],
    alt: 'Midsize jet offering greater range and space',
  },
  large: {
    src: '/imgs/svg/jet/Jet-2.svg',
    models: ['Citation X', 'Citation Sovereign', 'Falcon 50EX', 'Hawker 1000'],
    alt: 'Midsize jet offering greater range and space',
  },
  heavy: {
    src: '/imgs/svg/jet/Jet-1.svg',
    models: ['Gulfstream G-IVSP', 'Gulfstream G450', 'Challenger 604', 'Challenger 605'],
    alt: 'Large-cabin heavy jet with bespoke accommodations',
  },
  ultra: {
    src: '/imgs/svg/jet/Jet-0.svg',
    models: ['Gulfstream G-650ER', 'Gulfstream G-V', 'Gulfstream G-700', 'Global Express'],
    alt: 'Global, ultra-long-range private jet ready for international travel',
  },
};

const Flight = () => {
  const [active, setActive] = React.useState('light');
  const [expanded, setExpanded] = React.useState('light');

  const onToggle = (key) => {
    setActive(key);
    setExpanded((prev) => (prev === key ? key : key));
  };
  return (
    <Container>
      <Header
        title={
          <>
            Find the Right Jet for <br />
            Your Flight
          </>
        }
        desc={[
          "We provide access to a diverse selection of aircraft to suit your travel requirements, regardless of your journey's length.",
          'Explore our extensive network and jet card pricing options. All flights are conducted by licensed and thoroughly vetted operators within our trusted network of top-tier professionals.',
        ]}
      />
      <Grid>
        <Tabs>
          {tabs.map((tab) => {
            const { key, title, capacity, desc, rate } = tab;
            return (
              <React.Fragment key={key}>
                {expanded === key ? (
                  <Panel>
                    <Top>
                      <PanelTitle>{title}</PanelTitle>
                      <PanelDesc>{capacity}</PanelDesc>
                    </Top>
                    <PanelDesc>{desc}</PanelDesc>
                    <PanelRate>{rate}</PanelRate>
                    <BookBtn href="/charterQuote">Book Flight</BookBtn>
                  </Panel>
                ) : (
                  <TabButton $active={expanded === key} onClick={() => onToggle(key)}>
                    {title}
                  </TabButton>
                )}
              </React.Fragment>
            );
          })}
        </Tabs>
        <RightPanel>
          <Plane src={cardByKey[active].src} alt="aircraft" />
          <ModelsTitle>Models include</ModelsTitle>
          <Models>
            {cardByKey[active].models.map((m, i) => (
              <span key={i}>{m}</span>
            ))}
          </Models>
        </RightPanel>
      </Grid>
    </Container>
  );
};

export default Flight;
